export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/sqlite.635cf5f.svg";